/**
 * R-16 — inline Unicode superscript markers linking to amendment footnotes.
 */
import React from 'react';

export interface AmendmentMarkerProps {
  markerIds: string[];
  /** Map marker id → superscript char; defaults to passthrough. */
  idToChar?: (id: string) => string;
}

export function AmendmentMarkerSpans({
  markerIds,
  idToChar = (id) => id,
}: AmendmentMarkerProps): React.ReactElement | null {
  if (!markerIds.length) return null;
  return (
    <>
      {markerIds.map((id) => {
        const char = idToChar(id);
        return (
          <sup
            key={id}
            className="text-[0.65em] text-text-muted font-normal ml-px select-none"
            data-amendment-marker={id}
          >
            <a
              href={`#amendment-fn-${id}`}
              className="text-text-muted hover:text-text-secondary no-underline hover:underline"
              title="User amendment – see footnotes"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById(`amendment-fn-${id}`)?.scrollIntoView({ behavior: 'smooth', block: 'center' });
              }}
            >
              {char}
            </a>
          </sup>
        );
      })}
    </>
  );
}
